import { useEffect, useState } from "react";
import { getUserDataByEmail } from "../utils/getUserData";

export function useFpUserData(userEmail) {
  const [userData, setUserData] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
    const [userError, setUserError] = useState("");
    
    // console.log("useFpUserData - userEmail:", userEmail);

  useEffect(() => {
    let mounted = true;

    async function run() {
      if (!userEmail) {
        setUserData(null);
        setUserLoading(false);
        return;
      }

      setUserLoading(true);
      setUserError("");

      try {
        const data = await getUserDataByEmail(userEmail);
        if (mounted) setUserData(data);
      } catch (e) {
        if (mounted) setUserError(e?.message || "Failed to fetch user data");
      } finally {
        if (mounted) setUserLoading(false);
      }
    }

    run();
    return () => {
      mounted = false;
    };
  }, [userEmail]);

  return { userData, userLoading, userError };
}
